import { TimeScale, VolumeComparisonType } from 'types'

const COMPARISON_TYPE_SUPPORTING_FUTURE: string[] = [
  VolumeComparisonType.Forecasts,
  VolumeComparisonType.LastWeek,
  VolumeComparisonType.FourWeekAverage,
]

export const checkFutureDateRangeSupported = ({
  timeScale,
  comparisonType,
}: {
  timeScale: TimeScale
  comparisonType: VolumeComparisonType
}) =>
  timeScale === TimeScale.Hourly &&
  COMPARISON_TYPE_SUPPORTING_FUTURE.includes(comparisonType)
